<template>
  <div class="form-group">
    <label for="client">
      {{ $t('purchase.selectParentPurchase') }}:
    </label>

    <div :class="{
      'form-control': true,
      'is-select': true
    }">
      <v-select
        :options="purchases"
        v-model="purchase_id"
        :reduce="purchase => purchase.id"
        :filterBy="filterByForPurchases"
        :placeholder="$t('purchase.selectPurchase')"
        label="orders_names"
        :disabled="readOnly"
        @search="debouncedFetchPurchases">
        <template slot="no-options">
          <template v-if="!emptyResults">{{ $t('ui.searching') }}&hellip;</template>
          <template v-if="emptyResults">{{ $t('purchase.noPurchasesMatchingPhrase') }}&hellip;</template>
        </template>
        <template slot="option" slot-scope="option">
          <div class="d-center">
            {{ option.orders_names }} (#{{ option.id }})
          </div>
        </template>
        <template slot="selected-option" slot-scope="option">
          <div class="selected d-center">
            {{ option.orders_names }} (#{{ option.id }})
          </div>
        </template>
      </v-select>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'select-purchase',
  props: [
    'purchaseCategory',
    'customerID',
    'warehouse',
    'readOnly'
  ],
  computed: {
    purchaseParams () {
      return [
        this.purchaseCategory,
        this.customerID,
        this.warehouse
      ].join(';');
    }
  },
  watch: {
    purchase_id (newValue) {
      if (newValue !== 0 && newValue !== null) {
        let purchaseData = this.purchases.filter(purchase => purchase.id === newValue);

        if (!purchaseData[0]) {
          this.$bus.$emit('purchase-parent-has-been-reset', false);
          this.selectedPurchase = null;
          this.purchase_id = null;
        }
      } else {
        this.$bus.$emit('purchase-parent-has-been-reset', false);
        this.selectedPurchase = null;
      }

      this.$bus.$emit('purchase-select-change', this.purchase_id);
    },
    purchaseParams () {
      let sendResetNotice = false;

      if (this.purchase_id) {
        sendResetNotice = true;
      }

      this.selectedPurchase = null;
      this.purchase_id = null;
      this.$bus.$emit('purchase-select-change', null);
      this.loadData();

      if (sendResetNotice) {
        setTimeout(() => {
          this.$bus.$emit('purchase-parent-has-been-reset', true);
        }, 0);
      }
    }
  },
  data () {
    return {
      purchase_id: null,
      purchases: [],
      emptyResults: false,
      selectedPurchase: null,
      lastRequestID: null,
      loadPurchasesError: false
    }
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      this.lastRequestID = +new Date();
      let requestID = this.lastRequestID;
      this.emptyResults = false;

      FormUtils.loadAdditionalData(this, {
        requestID,
        method: 'get',
        endpoint: '/purchases/items',
        params: {
          where: {
            customer_id: this.customerID,
            warehouse: this.warehouse,
            purchase_category: this.purchaseCategory
          }
        },
        outputKey: 'purchases',
        errorKey: 'loadPurchasesError',
        successAction: (response) => {
          if (!response.length) {
            this.emptyResults = true;
          }
        }
      });
    },
    filterByForPurchases (option, label, search) {
      return option.orders_names.toLowerCase().indexOf(search.toLowerCase()) > -1;
    },
    loadPurchase (purchaseID, skipDataReload = false) {
      this.lastRequestID = +new Date();
      let requestID = this.lastRequestID;

      FormUtils.loadAdditionalData(this, {
        requestID,
        method: 'get',
        endpoint: '/purchases/item/' + parseInt(purchaseID, 10),
        outputKey: 'purchases',
        errorKey: 'loadPurchasesError',
        wrapResponseIntoArray: true,
        successAction: () => {
          if (skipDataReload && this.purchase_id) {
            let purchaseData = this.purchases.filter(purchase => purchase.id === this.purchase_id);

            if (purchaseData[0]) {
              this.selectedPurchase = JSON.parse(JSON.stringify(purchaseData[0]));
            }
          }

          this.purchase_id = parseInt(purchaseID, 10);
        }
      });
    },
    fetchPurchases (searchPhrase, loadingCallback) {
      this.emptyResults = false;
      loadingCallback(true);

      let endpointUrl = '/purchases/items';
      let responseAsArray = false;
      let paramsData = {
        customer_id: this.customerID,
        warehouse: this.warehouse,
        purchase_category: this.purchaseCategory
      };

      if (searchPhrase !== '') {
        paramsData.where = {
          search: searchPhrase,
          can_assign_to_this: 1,
          customer_id: this.customerID,
          warehouse: this.warehouse,
          purchase_category: this.purchaseCategory
        };
      }

      if (this.purchase_id !== 0 && this.purchase_id !== null && searchPhrase === '') {
        endpointUrl = '/purchases/item/' + parseInt(this.purchase_id, 10);
        responseAsArray = true;
      }

      this.lastRequestID = +new Date();
      let requestID = this.lastRequestID;

      FormUtils.loadAdditionalData(this, {
        requestID,
        method: 'get',
        endpoint: endpointUrl,
        outputKey: 'purchases',
        errorKey: 'loadPurchasesError',
        params: paramsData,
        wrapResponseIntoArray: responseAsArray,
        successAction: (response) => {
          if (!response.length) {
            this.emptyResults = true;
          }

          loadingCallback(false);
        }
      });
    },
    // eslint-disable-next-line
    debouncedFetchPurchases: debounce(function (searchPhrase, loadingCallback) {
      this.fetchPurchases(searchPhrase, loadingCallback);
    }, 500)
  }
}
</script>
